import { apiClient } from '@/client'
import moment from 'moment'
import {
  newFromPayload,
  compactAndFilter,
} from '@/utils'
import router from '@/router'

const defaultParams = {
  to: moment().format('YYYY-MM-DD'),
  from: moment().subtract(30, 'days').format('YYYY-MM-DD'),
}
const module = 'tenancy'
export default {
  namespaced: true,
  state: {
    loading: false,
    // Search data
    doc: {
      list: {
        actions: [
          { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
        ],
        search: [
          { label: 'Début', type: 'date', name: 'from', classes: 'md6' },
          { label: 'Fin', type: 'date', name: 'to', classes: 'md6' },
          { label: 'Région', source: 'regions', from: 'name', type: 'multilist', name: 'region_id' },
          { label: 'Ville', source: 'cities', from: 'name', type: 'multilist', name: 'city_id' },
          { label: 'District', source: 'districts', from: 'name', type: 'multilist', name: 'district_id' },
          { label: 'Type de panneau', source: 'boardtypes', from: 'name', type: 'multilist', name: 'board_type_id' },
          { label: 'Panneau', source: 'boards', from: 'code', type: 'multilist', name: 'board_id' },
          { label: 'Face', source: 'faces', from: 'full_code', type: 'multilist', name: 'id' },
        ],
      },
      params: {
        fetchAll: defaultParams,
        fetchOne: {},
      },
    },
    search: {
      dialog: false,
      data: defaultParams,
    },
    data: {count: 0, value: 0},
    hasError: false,
    errors: {},
    saved: false,
    showAlert: false,
  },
  getters: {
    search: state => state.search,
    doc: state => state.doc,
    data: state => ({ count: state.data.count, value: `${state.data.value} %` }),
    isLoading: state => state.loading,
  },
  mutations: {
    OPEN_SEARCH: (state, payload) => {
      state.search.dialog = true
    },
    RESET_SEARCH: (state, payload) => {
      state.search.data = defaultParams
      state.data = {count: 0, value: 0}
    },
    CLOSE_SEARCH: (state, payload) => {
      state.search.dialog = false
    },
    UPDATE_SEARCH_FIELD: (state, payload) => {
      state.search.data = newFromPayload(state.search.data, payload)
    },
    GET_REQUEST: (state, payload) => {
      state.loading = true
    },
    GET_SUCCESS: (state, payload) => {
      state.data = payload
      state.loading = false
      state.hasError = false
    },
    GET_ERROR: (state, payload) => {
      state.loading = false
      state.errors = payload
      state.hasError = true
    },
    EXPORT_REQUEST: (state, payload) => {
      console.log(payload)
      state.loading = true
    },
    EXPORT_PROGRESS: (state, payload) => {
      console.log(payload)
    },
    EXPORT_SUCCESS: (state, payload) => {
      state.loading = false
      const {filename, blob} = payload
      const url = window.URL.createObjectURL(blob)
      // window.open(url)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },
    EXPORT_ERROR: (state, payload) => {
      state.loading = false
    },

  },
  actions: {
    openSearch: ({ commit }, payload) => {
      commit('OPEN_SEARCH')
    },
    closeSearch: ({ commit }, payload) => {
      commit('CLOSE_SEARCH')
    },
    resetSearch: ({ commit }, payload) => {
      commit('RESET_SEARCH')
    },
    updateSearchField: ({ commit }, payload) => {
      commit('UPDATE_SEARCH_FIELD', payload.data)
    },
    search: ({ commit }, payload) => {
      const { data, context } = payload
      commit('GET_REQUEST', payload)
      let compacted = compactAndFilter(data)
      apiClient.fetchAll(module, {...context.params, ...compacted})
        .then(data => {
          commit('GET_SUCCESS', data)
        })
        .catch(error => {
          commit('GET_ERROR', error)
        })
    },
    export: ({ commit }, payload) => {
      const { data, context } = payload
      let compacted = compactAndFilter(data)
      let params = {format: context.format, ...context.params, ...compacted}
      commit('EXPORT_REQUEST', payload)
      const callBack = event => { commit('EXPORT_PROGRESS', event) }
      apiClient._download(module, `stats/tenancy`, {}, params, callBack)
        .then(response => {
          commit('EXPORT_SUCCESS', response)
        })
        .catch(error => {
          commit('EXPORT_ERROR', error)
        })
    },
    getTenancy: ({ commit, dispatch }, payload) => {
      const { context, data } = payload
      console.log(data)
      commit('RESET_SEARCH')
      commit('UPDATE_SEARCH_FIELD', {key: context.field, value: [data]})
      router.push({ name: 'tenancy' })
    },
    getMultiTenancy: ({ commit, dispatch }, payload) => {
      const { context, data } = payload
      console.log(data)
      commit('RESET_SEARCH')
      commit('UPDATE_SEARCH_FIELD', {key: context.field, value: data})
      router.push({ name: 'tenancy' })
    },
  },
}
